import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { createContactpersoonForEntity } from '../services/createContactpersoonForEntity'

import { queryKey as queryKeyContactpersonen } from './useContactpersonenForEntity'

export { useCreateContactpersoonForEntity }

const useCreateContactpersoonForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: createContactpersoonForEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyContactpersonen] })
      successAlert('Contactpersoon aangemaakt')
    },
  })
}
